import React, { useEffect, useState } from "react";
import { Table, Form, Button } from "react-bootstrap";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import CollapseCard from "../Components/CollapseCard";
import { getAllRates, saveRate } from "../Service/RateService";
import { useToast } from "../Components/toast/ToastProvider";

const RatePage = () => {
  const totalKm = 100;
  const rangeSize = 25;
  const [rateData, setRateData] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const initialRates = () =>
    Array.from({ length: rangeSize }, (_, row) =>
      Array.from({ length: totalKm / rangeSize }, (_, col) => ({
        km: row + 1 + col * rangeSize,
        rate: '',
        // id: null,
      })))

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await getAllRates();
      const dataMap = new Map(
        (res.data || []).map((r) => [Number(r.km), { id: r.id, rate: Number(r.rate).toFixed(2) }])
      );

      const grid = initialRates().map((row) =>
        row.map((cell) => {
          const saved = dataMap.get(cell.km);
          return saved ? { ...cell, ...saved } : cell;
        })
      );

      setRateData(grid);
    } catch (err) {
      console.error("Error fetching rates:", err);
      toast("Failed to load rates", { type: "error" });
    }
  };

  const handleRateChange = (row, col, value) => {
    const updated = rateData.map((r, rowIndex) =>
      r.map((c, colIndex) =>
        rowIndex === row && colIndex === col
          ? { ...c, rate: value }
          : c
      )
    );
    setRateData(updated);
  };
  const handleKeyDown = (e, rowIndex, colIndex) => {
    if (e.key === 'Enter') {
      e.preventDefault();

      const numRows = rateData.length;
      const numCols = rateData[0].length;

      let nextRow = rowIndex + 1;
      let nextCol = colIndex;


      if (nextRow >= numRows) {
        nextRow = 0;
        nextCol = colIndex + 1;

      }

      if (nextCol >= numCols) {
        const saveBtn = document.getElementById("saveRateBtn");
        if (saveBtn) {
          saveBtn.focus();
          saveBtn.click();
        }
      }
      const nextInput = document.querySelector(`input[data-row='${nextRow}'][data-col='${nextCol}']`);
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  const handleSaveAll = async () => {
    try {
      setLoading(true);
      const records = rateData
        .flat()
        .filter((c) => c.km != null && c.rate !== "" && !isNaN(c.rate))
        .map((c) => ({
          id: c.id || null,
          km: Number(c.km),
          rate: Number(c.rate),
        }));

      if (!records.length) {
        toast("No valid rates to save!", { type: "info" });
        return;
      }
      await saveRate({ records });


      const formattedGrid = rateData.map((row) =>
        row.map((cell) => {
          const saved = records.find(r => r.km === cell.km);
          return saved ? { ...cell, rate: saved.rate.toFixed(2) } : cell;
        })
      );

      setTimeout(() => {
        setLoading(false);
        toast('rates saved successfully', "SUCCESS");
      }, 1500)
      setRateData(formattedGrid)


    } catch (err) {
      console.error("Failed to save rates:", err);
    }
  };

  return (
    <Main>
      <PageContainer titlePage="Rate Master">
        <CollapseCard title='Rate'>
          <h5 className="mb-3">KM vs Rate</h5>
          <Table bordered hover responsive>
            <thead>
              <tr>
                {Array.from({ length: totalKm / rangeSize }).map((_, idx) => (
                  <React.Fragment key={idx}>
                    <th style={{ textAlign: "center" }}>KM</th>
                    <th style={{ textAlign: "center" }}>Rate</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            <tbody>
              {rateData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, colIndex) => (
                    <React.Fragment key={colIndex}>
                      <td style={{ textAlign: "center" }}>{cell.km}</td>

                      <td>
                        <Form.Control
                          type="number"
                          min={0}
                          value={cell.rate !== undefined ? cell.rate : ''}
                          // value={cell.rate !== undefined && cell.rate !== '' ? Number(cell.rate).toFixed(2) : "0.00"}
                          onChange={(e) =>
                            handleRateChange(rowIndex, colIndex, e.target.value)
                          }
                          onKeyDown={(e) => handleKeyDown(e, rowIndex, colIndex)}
                          data-row={rowIndex}
                          data-col={colIndex}
                          style={{ width: "95px" }}
                        />
                      </td>
                    </React.Fragment>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="d-flex justify-content-end mt-2">
            <Button id="saveRateBtn" variant="primary" onClick={handleSaveAll}
              disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  saving...
                </>
              ) : (
                " Save"
              )}

            </Button>
          </div>
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default RatePage;
